<template>
  <uni-uploader
    multiple
    library
    :files="fileList"
    :selectable="enableSelection"
    @change="onChange"
    @selection="files => $emit('image-update', files)"
  >
    <template #file-preview="scope">
      <slot
        name="file-preview"
        v-bind="scope"
      />
    </template>
    <template #actions="scope">
      <slot
        name="actions"
        v-bind="scope"
      />
    </template>
  </uni-uploader>
</template>

<script>
import UniUploader from './uploader/UniUploader.vue'

/**
 * Several files of a record (a product's pictures, the pictures of an additional field): `file-list` is what the
 * record has, `@input` gives the ids and `@files-change` the file objects after every upload and removal. Removing a
 * file here only takes it off the record: the file stays in the library, where other records may be showing it (it
 * used to be deleted on the server).
 *
 * The props and events are the ones the pages have always used; the uploading itself is UniUploader.
 */
export default {
  name: 'FileMultiUploader',
  components: { UniUploader },
  props: {
    fileList: { type: Array, default: () => [] },
    enableSelection: { type: Boolean, default: false },
    /** the ids (`v-model`); the list itself comes from `file-list` */
    value: { type: Array, default: undefined },
  },
  methods: {
    onChange(files) {
      this.$emit('input', files.map(file => file.id))
      this.$emit('files-change', files)
    },

  },
}
</script>
